import { EVENT_APPRAISER_ASSIGNMENT_ROLE } from '../constants/EventAppraiserAssignmentRole';
import { TEAM_ROLE_ASSIGNMENT_TYPES_MAP } from '../constants/EventTeamRoleAssignmentTypes';

export const getEventTeamRoleAssignmentSettings = (eventTeams, eventAssignments) => {
  return TEAM_ROLE_ASSIGNMENT_TYPES_MAP.map(teamRoleAssignmentSettings => ({
    ...teamRoleAssignmentSettings,
    ...getTeamRoleAssignmentStatuses(eventTeams, eventAssignments, teamRoleAssignmentSettings.role),
    ...getTeamRoleTakenRankings(eventAssignments, teamRoleAssignmentSettings.role)
  }));
};

const getTeamRoleAssignmentStatuses = (eventTeams, eventAssignments, teamRole) => {
  const numberOfPeopleForTeamRole = getNumberOfPeopleForTeamRole(eventTeams, teamRole);

  const primaryAssignmentsCountForRole = getPrimaryAssignmentsCountForRole(
    eventAssignments,
    teamRole
  );

  return {
    hasPositiveNumberOfPeople: numberOfPeopleForTeamRole > 0,
    isAssignmentFilled: numberOfPeopleForTeamRole <= primaryAssignmentsCountForRole
  };
};

const getTeamRoleTakenRankings = (eventAssignments, teamRole) => {
  const takenRankings = eventAssignments?.filter(assignment =>
    assignment.teamRole === teamRole &&
    assignment.assignmentRank
  ).map(assignment => assignment.assignmentRank);

  return { takenRankings };
};

const getNumberOfPeopleForTeamRole = (eventTeams, teamRole) =>
  eventTeams?.find(team => teamRole === team.role)?.numberOfPeople ?? 0;

const getPrimaryAssignmentsCountForRole = (eventAssignments, teamRole) => {
  return (
    eventAssignments?.filter(
      assignment =>
        assignment.teamRole === teamRole &&
        assignment.role === EVENT_APPRAISER_ASSIGNMENT_ROLE.PRIMARY
    ).length ?? 0
  );
};
